import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { AttributeValue, AttributeValueCreate, AttributeValueFilter } from '../data/attributeValue';

export function createAttributeValueService(client: AxiosInstance) {
  return createCrudService<AttributeValue, AttributeValueCreate, AttributeValueFilter>(client, '/AttributeValue', 'attributeValueId');
}

export type AttributeValueService = CrudService<AttributeValue, AttributeValueCreate, AttributeValueFilter>;
